import { Component } from "react"
import PropTypes from "prop-types"
import { toUpper, keys, isEmpty, map, get, every, pick, take } from "lodash"
import { List, ListItemButton, ListItemIcon, ListItemText, ListSubheader, Button, Badge, Collapse } from "@mui/material"
import { ExpandLess, ExpandMore, CheckBoxOutlineBlank, CheckBox, IndeterminateCheckBox } from "@mui/icons-material"
import Tooltip from "components/material/tooltip"
import { SELECTED_CLASSIFICATION, TIER } from "../../shapes"
import FacetListItem from "../list-item"

const SELECTED = {
  NONE: 0,
  SOME: 1,
  ALL: 2,
}

function amISelected(facets) {
  if (every(facets, (f) => f.selected)) {
    return SELECTED.ALL
  }
  if (every(facets, (f) => !f.selected)) {
    return SELECTED.NONE
  }
  return SELECTED.SOME
}
export default class FacetTieredList extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    facets: PropTypes.objectOf(TIER).isRequired,
    selected: PropTypes.objectOf(SELECTED_CLASSIFICATION).isRequired,
    toggleFacet: PropTypes.func.isRequired,
    toggleClassificationFacets: PropTypes.func.isRequired,
    expandFacet: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      open: {},
    }
  }

  onClick = (id, tier, selected) => {
    const { type, toggleClassificationFacets } = this.props
    toggleClassificationFacets(type, tier, [id], selected)
  }

  toggleTier = (id) => {
    const { open } = this.state
    const newOpen = {
      ...open,
      [id]: !get(open, id, false),
    }
    this.setState({ open: newOpen })
  }

  checkTier = (e, id, tier, selectedState) => {
    const { type, facets, toggleClassificationFacets } = this.props
    const { open } = this.state
    const selected = !(selectedState === SELECTED.ALL)
    const ids = keys(get(facets, `${id}.facets`))
    toggleClassificationFacets(type, tier, ids, selected)
    // If unchecking a group or if the group Collapse is already opened
    // dont open the Collapse element
    if (!selected || get(open, tier)) {
      e.stopPropagation()
    }
  }

  expand = (id) => {
    const { type, expandFacet } = this.props
    expandFacet(`${type}.${id}`)
  }

  render() {
    const { type, facets, selected } = this.props
    const { open } = this.state
    if (isEmpty(keys(facets))) {
      return null
    }

    const actualSelected = get(selected, type)
    const tooltip = <>{map(actualSelected, (f, i) => <div key={i}>{f.label} - {f.id}</div>)}</>
    return <List
      key={type}
      subheader={<ListSubheader className="category-header">
        {keys(actualSelected).length > 0
          ? <Badge
              color="secondary"
              badgeContent={<Tooltip title={tooltip}>
                <span>{keys(actualSelected).length}</span>
              </Tooltip>}
              classes={{ badge: "badge" }}
          >
            {toUpper(type)}
          </Badge> : toUpper(type)}

      </ListSubheader>}
    >
      {map(facets, (facet, tier) => {
        const { facets: subFacets } = facet
        if (keys(subFacets).length <= 1) {
          return null
        }
        const isOpen = get(open, facet.id, false)
        const selectedState = amISelected(subFacets)
        return (<div key={`top-${facet.id}`}>
          <div className="top-tier" onClick={() => this.toggleTier(facet.id)}>
            <ListItemButton
              key={facet.id}
              className="facet-list-item"
            >
              <ListItemIcon className="facet-list-icon" onClick={(e) => { this.checkTier(e, tier, facet.id, selectedState) }}>
                <span data-type="input" className="MuiIconButton-label fake-checkbox">
                  {selectedState === SELECTED.NONE && <CheckBoxOutlineBlank size="large" />}
                  {selectedState === SELECTED.SOME && <IndeterminateCheckBox size="large" />}
                  {selectedState === SELECTED.ALL && <CheckBox size="large" />}
                </span>
              </ListItemIcon>
              <ListItemText>{facet.name}</ListItemText>
              {isOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          </div>
          <Collapse key={`collapse-${facet.id}`} in={isOpen} timeout="auto">
            <hr className="column-divider no-top-margin" />
            {map(getFirst5(subFacets), (f) => (<FacetListItem key={f.id} {...f} onClick={() => this.onClick(f.id, tier, !f.selected)} />))}
            {keys(subFacets).length > 5 && <Button color="primary" onClick={() => this.expand(facet.id)}>See More</Button>}
            <hr className="column-divider" />
          </Collapse>
        </div>)
      })}
    </List>
  }
}

function getFirst5(obj) {
  const objKeys = take(keys(obj), 5)

  return pick(obj, objKeys)
}
